import { Box, Grid, Paper } from '@atgfr8/atg-ui-tailwind';
import { Show } from 'solid-js';

import { hasInsurance } from './insurance';
import { QuoteCarrierDetails } from './QuoteCarrierDetails';
import { QuoteCostDetails } from './QuoteCostDetails';
import {
  DEFAULT_QUOTE_DETAILS_LABELS,
  QuoteDetailsLabels,
  QuoteDetailsRowRenderProps,
  showsActions,
  showsTerminalInfo,
} from './types';

/**
 * Shared LTL quote detail row used by Saved Quotes, History, New Quote results
 * and the customer-detail Test Lane. Purely presentational: every behaviour
 * comes in through `actions`, every screen difference through `variant`.
 */
export const QuoteDetailsRowRender = (props: QuoteDetailsRowRenderProps) => {
  const withInsurance = () => hasInsurance(props.insurance);

  const label = (key: keyof QuoteDetailsLabels) =>
    props.labels?.[key] ?? DEFAULT_QUOTE_DETAILS_LABELS[key];

  const labels = (): QuoteDetailsLabels => ({
    select: label('select'),
    addInsurance: label('addInsurance'),
    selectInsurance: label('selectInsurance'),
  });

  return (
    <Box class="p-2 mb-2" data-testid={`quoteDetailsRow-${props.quote.id}`}>
      <Grid container spacing={2} class="w-full">
        <Grid item size={{ xs: 12, lg: withInsurance() ? 7 : 8 }}>
          <Paper elevation={3} class="px-3! py-4! h-full w-full">
            <QuoteCarrierDetails
              quote={props.quote}
              showTerminalInfo={showsTerminalInfo(props.variant)}
              carrierNameDataTestId={props.carrierNameDataTestId}
              onOpenLiabilityInfo={props.actions?.onOpenLiabilityInfo}
            />
          </Paper>
        </Grid>

        <Grid item size={{ xs: 12, lg: withInsurance() ? 2.5 : 4 }}>
          <Paper elevation={3} class="px-3! py-4! h-full w-full">
            <QuoteCostDetails
              quote={props.quote}
              customerId={props.customerId}
              insurance={props.insurance}
              isInsuranceCard={false}
              showActions={showsActions(props.variant)}
              actions={props.actions}
              labels={labels()}
            />
          </Paper>
        </Grid>

        <Show when={withInsurance()}>
          <Grid item size={{ xs: 12, lg: 2.5 }}>
            <Paper elevation={3} class="px-3! py-4! h-full w-full">
              <QuoteCostDetails
                quote={props.quote}
                customerId={props.customerId}
                insurance={props.insurance}
                isInsuranceCard={true}
                showActions={showsActions(props.variant)}
                actions={props.actions}
                labels={labels()}
              />
            </Paper>
          </Grid>
        </Show>
      </Grid>
    </Box>
  );
};
